import Vue from 'vue'



//价格
Vue.directive('enterPrice',{
  inserted: function (el) {
    el.addEventListener("keypress",function(e){
      e = e || window.event;
      let value = el.value + '' + e.key;
      let reg = /^[0-9]{0,4}\.{0,1}[0-9]{0,2}$/
      let srkey = [46,48,49,50,51,52,53,54,55,56,57]  /* 允许输入.0123456789  的code*/
      if(!reg.test(value)||value >= 10000||value == '00'||srkey.indexOf(e.keyCode)==-1){
        e.preventDefault();
      }
      else {
        el.dispatchEvent(new Event("input"))
      }
    });
    el.addEventListener('input',function () {
      if(el.value=='') return
      
      let reg = /^[0-9]{0,4}\.{0,1}[0-9]{0,2}$/
      let event = false;
      if(/^0[0-9]{1,2}$/.test(el.value)){
        el.value = el.returnValue || ''
        event = true
      }else if(!reg.test(el.value.toString()) || el.value > 10000){
        el.value = el.returnValue
        event = true
      }
      el.returnValue = el.value
      if(event){
        el.value=='undefined'?el.value = '':''
        el.dispatchEvent(new Event("input"))
      }
    })
  }
})


//只能输入8位纯数字  DEMO 12345678
Vue.directive('enterNumber',{
  inserted: function (el) {
    el.addEventListener("keypress",function(e){
      e = e || window.event;
      let value = el.value + '' + e.key;
      let reg = /^[0-9]{0,8}$/
      let srkey = [48,49,50,51,52,53,54,55,56,57]  /* 允许输入0123456789  的code*/
      if(!reg.test(value)||value >= 100000000||value == '00'||srkey.indexOf(e.keyCode)==-1){
        e.preventDefault();
      }
      else {
        el.dispatchEvent(new Event("input"))
      }

    });
    el.addEventListener('input',function () {
      if(el.value=='') return
      let reg = /^[0-9]{0,8}$/
      let event = false;
      if(/^0[0-9]{1,2}$/.test(el.value)){
        el.value = el.returnValue || ''
        event = true
      }else if(!reg.test(el.value.toString()) || el.value > 100000000){
        el.value = el.returnValue
        event = true
      }
      el.returnValue = el.value
      if(event){
        el.value=='undefined'?el.value = '':''
        el.dispatchEvent(new Event("input"))
      }
    })
  }
})

// 只能输入11位纯数字  DEMO 手机号码
Vue.directive('enterTel', {
  inserted: function(el) {
    el.addEventListener('keypress', function(e) {
      e = e || window.event
      const value = el.value + '' + e.key
      const reg = /^1[0-9]{0,10}$/
      const srkey = [
        48, 49, 50, 51, 52, 53, 54, 55, 56, 57
      ] /* 允许输入0123456789  的code*/
      if (
        !reg.test(value) ||
        value >= 100000000000 ||
        value == '00' ||
        srkey.indexOf(e.keyCode) == -1
      ) {
        if (e.target.selectionEnd - e.target.selectionStart > 0) {
          el.dispatchEvent(new Event('input'))
        } else {
          e.preventDefault()
        }
      } else {
        el.dispatchEvent(new Event('input'))
      }
    })
    el.addEventListener('input', function() {
      if (el.value == '') return
      const reg = /^1[0-9]{0,10}$/
      let event = false
      if (/^0[0-9]{1,2}$/.test(el.value)) {
        el.value = el.returnValue || ''
        event = true
      } else if (!reg.test(el.value.toString()) || el.value > 100000000000) {
        el.value = el.returnValue
        event = true
      }
      el.returnValue = el.value
      if (event) {
        el.value == 'undefined' ? (el.value = '') : ''
        el.dispatchEvent(new Event('input'))
      }
    })
  }
})

// 回到顶部
Vue.directive('back-to-top', {
  bind(el, binding ){
    const { value } = binding
    
    // 创建一个回到顶部的按钮
    const img = document.createElement('img');
    img.src = 'https://xhdata.wan4.com/wsw-h5-27.png';
    img.style.position = 'fixed';
    img.style.bottom = value || (document.getElementById('homeTabbar') ?  '2.293333rem' : '1.013333rem');
    img.style.width = '1.25333rem'
    img.style.height = '1.25333rem'
    img.style.right = '0.426666rem';
    img.style.display = 'none';
    img.style.zIndex = 1000
    img.addEventListener('click', ()=>{
      el.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    })
    // 将按钮添加到绑定元素的后面
    el.appendChild(img);
    const handleScroll = (e) => {
      if (e.target.scrollTop > e.target.offsetHeight) {
        img.style.display = 'block';
      } else {
        img.style.display = 'none';
      }
    };
    el._scrollEventListener = handleScroll;
    el.addEventListener('scroll', handleScroll);
  },
  unbind(el) {
    el.removeEventListener('scroll', el._scrollEventListener);
  }
})